import { SET_WARNING, CLOSE_WARNING } from "./type";

export const setWarning = (alert, confirm, cancel, width, height) => ({
  type: SET_WARNING,
  payload: { alert, confirm, cancel, width, height }
});

export const closeWarning = () => ({ type: CLOSE_WARNING, payload: {} });
